module.exports = __webpack_public_path__ + "static/media/people-min.9224b917.jpg";